import { useCallback } from "react";
import api from "../../../Component/axios";

export const useProyeccionDiaria = () => {
  const token = localStorage.getItem("@Token");
  const getProyeccionDiaria = useCallback(
    async (fecha, id_variedad, color_id) => {
      try {
        const response = await api.get(
          `api/programacion/diaria/?fecha=${fecha}&id_variedad=${id_variedad}&color_id=${color_id}`,
          {
            headers: {
              Authorization: "Token " + token,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [token]
  );

  return { getProyeccionDiaria };
};
